import styled from '@emotion/styled';
import { getColor } from '../../common/UICommon';
import { TabletWidth } from '../../../global.style';

export const PickAProductContentV2Wrapper = styled.div`
  padding-top: 140px;
  padding-bottom: 210px;
  overflow: hidden;

  @media (max-width: ${TabletWidth}px) {
    padding-top: 75px;
    padding-bottom: 180px;
  }
`;

export const PickAProductInfo = styled.p`
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  color: ${getColor('GRAY_60')};
  margin-top: 24px;
  text-align: center;
  white-space: pre-line;

  @media (max-width: ${TabletWidth}px) {
    margin-top: 16px;
  }
`;

export const PickAProductStickyInfo = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  color: ${getColor('GRAY_60')};
  white-space: pre-line;
`;

export const PickAProductDesktopCtaSection = styled.div`
  max-width: 1120px;
  margin: auto;
  border-bottom: 1px solid ${getColor('GRAY_40')};
  padding-bottom: 60px;

  @media (max-width: ${TabletWidth}px) {
    display: none;
  }
`;

export const PickAProductDesktopWrapper = styled.div`
  max-width: 330px;
  width: 100%;
  z-index: 1;
  margin: auto;
`;

export const PickAProductStickyHeader = styled.div<{ isVisible: boolean }>`
  width: 100%;
  position: fixed;
  top: 0;
  background-color: ${getColor('BEIGE_5')};
  z-index: 99;
  border-bottom: 1px solid ${getColor('GRAY_40')};
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  transform: ${({ isVisible }) => (isVisible ? 'translateY(0)' : 'translateY(-100%)')};
  transition: opacity 0.3s ease, transform 0.3s ease;
  transition: visibility 0s linear 0.3s, opacity 0.3s ease, transform 0.3s ease;

  @media (max-width: ${TabletWidth}px) {
    display: none;
  }
`;

export const PickAProductStickyHeaderContent = styled.div`
  max-width: 1440px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 22px 20px 22px 32px;
`;

export const PickAProductStickyHeaderButtonWrapper = styled.div`
  max-width: 250px;
  width: 100%;
`;

export const PickAProductMobileCtaSection = styled.div`
  display: none;

  @media (max-width: ${TabletWidth}px) {
    background-color: ${getColor('DARK_CREAM')};
    border-top: 1px solid ${getColor('GRAY_20')};
    display: block;
    position: fixed;
    bottom: 0px;
    width: 100%;
    z-index: 2;
    padding: 16px 24px;
  }
`;

export const PickAProductMobileCtaSectionContent = styled.div`
  max-width: 330px;
  margin: auto;
`;
